import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { captureFeatureFlagBypassToken } from './app/infraestructure/helpers/feature-flags/feature-flag-bypass.helper';

if (environment.production) {
  enableProdMode();
}

// Capture the feature flag bypass token from the URL before FeatureFlagsService
// fires its GET /feature-flags request in its constructor.
captureFeatureFlagBypassToken();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
